import {CatmullRomCurve3, MathUtils, ShaderMaterial, Vector3, Vector4} from 'three'

import type {BrandedDividerParams} from '../../../../components/WebGLContext/WebGLContext.types'
import {BREAKPOINT} from '../../../_rawConfig'
import BaseConpilot from './BaseCopilot'

const TUBE_LENGTH = 4

export default class Copilot2 extends BaseConpilot {
  constructor(params: BrandedDividerParams, rectData: Vector4) {
    super(params, rectData)

    const scale = 0.3
    this.group.scale.set(scale, scale, scale)
    this.group.position.z = 3
  }

  override createTl() {
    const delay = 0.5
    this.tl
      .to(
        this.progress,
        {
          x: 1,
          ease: 'elastic.out(1,1)',
          duration: 2.0,
        },
        delay,
      )
      .to(
        this.progress,
        {
          y: 1,
          ease: 'expo.out',
          duration: 1,
        },
        delay,
      )
      .to(
        this.progress,
        {
          z: 1,
          ease: 'expo.out',
          duration: 3,
        },
        delay,
      )
      .to(
        this.progress,
        {
          w: 1,
          ease: 'power2.out',
          duration: 3,
        },
        0,
      )

    super.createTl()
  }

  override createPath() {
    this.offsetPos.set(15.5, -0.8)
    this.curve = new CatmullRomCurve3([new Vector3(0, -TUBE_LENGTH, 0), new Vector3(0, 0, 0)])

    this.createTube()

    if (this.tube && this.tube.material instanceof ShaderMaterial) {
      this.tube.material.uniforms.uColor1!.value.set(0xffffff)
      this.tube.scale.set(1.2, 1.0, 1.2)
    }
  }

  override moveOnArc() {
    const t01 = this.progress.x

    const y = MathUtils.lerp(-TUBE_LENGTH, 0, t01)

    // position on XY plane
    this.group2.position.set(this.offsetPos.x, y + this.offsetPos.y + 1.0, 0)

    this.group2.rotation.set(0.3, -0.7 + (1.0 - this.progress.z) * Math.PI, 0)

    this.group2.scale.set(this.progress.y, this.progress.y, this.progress.y) // scale up from 0 to 1;

    if (this.tube) {
      this.tube.position.y = -(1 - t01) * TUBE_LENGTH
    }

    if (window.innerWidth < BREAKPOINT.MOBILE) {
      const scale = 0.85 * this.progress.y
      this.group2.scale.set(scale, scale, scale)
    }
  }
}
